<template>
<div class="mt_140">

      <ccMenu ref="cc_menu" v-bind:posicao=1></ccMenu>
      <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

      <div class="container">
      <div class="row">
      <div class="col-md-12">

        <!-- row -->
        <div class="row">

          <!-- coluna 2 -->
          <div class="col-md-2">
            <ccMenuConta :num=8></ccMenuConta>
          </div">
          <!-- fim coluna 2 -->

          <!-- coluna 10 -->
          <div class="col-md-10 pt-0 p-4" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">

                <ccContaConviteTopo v-bind:btn=2> </ccContaConviteTopo>
                <br>

                <!-- HISTORICO CONVIDADOS ------------------------------------>
                <section class="mb-2">
                  <div class="row">
                  <div class="col-md-12">

                      <div class="row">                        
                        <div class="col-md-2">
                            <div class="form-group mb-2 text_12">
                              <the-mask :mask="['##/##/####']" masked type="text" v-model="dt_inicio"
                              class="form-control form-control-sm"  placeholder="DD/MM/YYYY"/>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group mb-2 text_12">
                              <the-mask :mask="['##/##/####']" masked type="text" v-model="dt_fim"
                              class="form-control form-control-sm" placeholder="DD/MM/YYYY"/>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="form-group mb-2">
                              <button type="button" class="btn btn-secondary w-100 btn-sm" @click="get_historico()">Filtar</button>
                            </div>
                        </div>
                      </div>

                      <table class="table table-borderles text_branco text_10">
                        <thead>
                          <tr>
                            <th scope="col" width="19%" >DATA DE CADASTRO</th>
                            <th>ID USUÁRIO</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="convidado of convidados">
                            <td>{{convidado.created_at}}</td>
                            <td>{{convidado.id}}</td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
                  </div>
                </section>


                <!-- paginate -->
                <div class="row">
                  <div class="col-md-4">
                    <nav aria-label="...">
                      <ul class="pagination pagination-sm">
                        <li class="page-item text_cinza pe-3">Page: {{this.page}}</li>
                        <li class="page-item"><a class="page-link" href="#" @click="set_page('back')"> < </a></li>
                        <li class="page-item"><a class="page-link" href="#" @click="set_page('next')"> > </a></li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <!----------->

          </div>
          <!-- fim coluna 10 -->

      </div>
      <!-- fim row -->

    </div>
    </div>
    </div>

    <ccFooter></ccFooter>

</div>
</template>

<script>

import axios from 'axios';
import {TheMask} from 'vue-the-mask'
import ccMenu from '../layout/menu.vue'
import ccMenuConta from '../conta/menu_conta.vue'
import ccContaTopo from '../conta/topo.vue'
import ccContaConviteTopo from '../conta/convite_topo.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccFooter from '../layout/footer.vue'

export default {
  data () {
    return {
      titulo: 'CONVIDADOS',

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: true,
      errors: [],

      //variaveis
      page: 1,
      dt_inicio: null,
      dt_fim: null,
      convidados: [],
    }
  },

  components: {ccMenu, TheMask, ccContaTopo, ccContaConviteTopo, ccLoading, ccMenuConta, ccFooter},

  created()
  {
    document.title = 'Minha Conta: Convite Histórico - SokkerDuel';

    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let a = JSON.parse(localStorage.getItem("user"));
    
    if (a == null){ this.user = {} }else{ this.user = a }

    this.get_historico()
  },

  methods: {

    get_historico(){
      this.loading = true;

      var body = {
        page: this.page,
        dt_check: this.dt_check,
        dt_inicio: this.dt_inicio,
        dt_fim: this.dt_fim,
      };

      var header = {'headers': {'x-access-token': this.user.access_token, }};
      axios.post(this.base_url_api+'conta/convite/historico', body, header)
      .then(response => {

        //ajuste na paginacao
        // if(response.data.resp.length == 0){
        //     this.page--
        //     this.get_historico()
        // }

        this.page = response.data.page
        this.convidados = response.data.resp

        this.loading = false;
      })
      .catch(e => {
        this.errors.push(e);
        console.log(e)

        this.loading = false;
        
        this.expluse_para_login()
      });
    },

    set_page(p){      
      if(p=='back'){ 
        this.page > 1 ? this.page-- : this.page = 1 
      }

      if(p=='next'){ 
        this.page > 0 ? this.page++ : this.page = 1 
      }

      this.get_historico()
    },

  }

}
</script>

<style scoped>
  input.form-control{
    background-color: #21232d;
    border: none;
    color: #909196;
    margin-bottom: 10px;
  }

  select.form-control{
    background-color: #21232d;
    border: none;
    color: #909196;
    margin-bottom: 10px;
  }

  input.form-control::placeholder {
    color: #FFFFFF7F;
  }


  .page-item{
    background-color: transparent;
  }

  .page-link{
    background-color: transparent;
    text-decoration: none;
    font-size: 15px;
    font-family: bold;
    color: #cccccc;
    border: solid 1px #20222d;
  }

  .table-borderles{
    border: #90919640
  }
</style>



// WEBPACK FOOTER //
// src/components/conta/convite_historico.vue